import Substations from '@/resources/substations';
import RootStateCommit from '@/store/mixins/rootstate-commit';

const MODULE_NAME = 'substation';

export default {
  namespaced: true,
  actions: {
    add({ commit }, { projectCode, data }) {
      const action = Substations({ projectCode }).save(data);

      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      action.then(
        () => RootStateCommit(commit, 'stopLoading', MODULE_NAME),
        () => RootStateCommit(commit, 'stopLoading', MODULE_NAME)
      );

      return action;
    },
    edit({ commit }, { projectCode, code, data }) {
      const action = Substations({ projectCode }).update({ code }, data);

      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      action.then(
        () => RootStateCommit(commit, 'stopLoading', MODULE_NAME),
        () => RootStateCommit(commit, 'stopLoading', MODULE_NAME)
      );

      return action;
    }
  }
};
